import React from "react";
import { Fragment } from "react";
import "./App.css";
import Header from "./components/Header";
import Intro from "./components/Intro";
import Main from "./components/Main";
import Footer from "./components/Footer";
import { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import PageEnd from "./components/PageEnd";

const App = () => {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    axios.get("/db/data.json").then((res) => {
      setProjects(res.data);
    });
  }, []);

  return (
    <Fragment>
      <Header />
      <Intro />
      <Main projects={projects} />
      <PageEnd />
      <Footer />
    </Fragment>
  );
};

export default App;
